import { ActionContext, Store } from "vuex";
import { getStoreAccessors } from "vuex-typescript";
import { State as RootState } from "../state";
import { ActivityState } from "./activityState";
import { activityService } from "../../_services/activity-service";
import { Activities } from "../../_models/activities";
import { EnterpriseSubscription } from '@/_models/enterpriseSubscription';
import { IscrizioneAzienda } from '@/_models/iscrizioneAzienda';
import { IscrizioneAllievo } from '@/_models/iscrizioneAllievo';

type ActivityContext = ActionContext<ActivityState, RootState>;
const getDefaultState = () => {
    return {
        activities: [],
        instituteActivity: null
    }
}

export const activity = {
    namespaced: true,

    state: getDefaultState(),
    // state: {
    //     alternanza: false,
    //     incontro: false,
    //     workshop: false,
    //     colloquio: false,
    //     tirocinio: false,
    // },

    getters: {
        getInstituteActivityState(state: ActivityState) {
            return state.instituteActivity
        },
        getActivityState(state: ActivityState) {
            return state.activities
        }
    },

    mutations: {
        editInstituteActivityState(state: ActivityState, activities: Activities): void {
            state.instituteActivity = activities;
        },
        editActivityState(state: ActivityState, activities: Activities[]): void {
            activities.forEach(element => {
                state.activities.push(element)
            });
        },
        clearState(state: ActivityState) {
            Object.assign(state, getDefaultState())
        }
    },

    actions: {
        //per istituti
        getInstituteActivityState(context: ActivityContext, idInstitute: number) {
            return new Promise<Activities>((resolve, reject) => {
                var activities: Activities;
                var check: Activities | null = readInstituteActivitiesStatus(context)
                if (check === null || check === undefined) {
                    activityService.getInstituteActivityState(idInstitute)
                        .then(response => {
                            activities = {
                                idIstituto: response.IdIstituto,
                                denominazioneIstituto: response.Denominazione,
                                alternanza: response.Alternanza,
                                tirocinioFormativo: response.TirociniFormativi,
                                tirocinioEstivo: response.TirociniEstivi,
                                workshop: false,
                                colloquio: response.Colloqui,
                                incontro: false
                            }
                            commitEditInstituteActivityState(context, activities)
                            resolve(activities)
                        }).catch(error => {
                            reject(error)
                        })
                } else {
                    resolve(check)
                }
            })
        },
        //per aziende
        getActivityState(context: ActivityContext, idAzienda: number) {
            return new Promise<Activities[]>((resolve, reject) => {
                var activitiesList: Activities[] = [];
                var item: Activities;
                var check: Activities[] | null = readActivityState(context)
                if (check.length === 0 || check === undefined) {
                    activityService.getActivityState(idAzienda)
                        .then(response => {
                            response.forEach(function (element: any) {
                                item = {
                                    idIstituto: element.IdIstituto,
                                    denominazioneIstituto: element.Denominazione,
                                    alternanza: element.Alternanza,
                                    tirocinioFormativo: element.TirociniFormativi,
                                    tirocinioEstivo: element.TirociniEstivi,
                                    workshop: false,
                                    colloquio: element.Colloqui,
                                    incontro: false
                                }
                                activitiesList.push(item)
                            });
                            commitEditActivityState(context, activitiesList)
                            resolve(activitiesList)
                        }).catch(error => {
                            reject(error)
                        })
                } else {
                    resolve(check)
                }
            })
        },

        editInstituteActivityState(context: ActivityContext, activitiesState: Activities) {
            return new Promise<string>((resolve, reject) => {
                var activities: Activities = {
                    idIstituto: activitiesState.idIstituto,
                    denominazioneIstituto: activitiesState.denominazioneIstituto,
                    alternanza: activitiesState.alternanza,
                    tirocinioFormativo: activitiesState.tirocinioFormativo,
                    tirocinioEstivo: activitiesState.tirocinioEstivo,
                    workshop: activitiesState.workshop,
                    colloquio: activitiesState.colloquio,
                    incontro: activitiesState.incontro
                }
                activityService.editInstituteActivityState(activities)
                    .then(() => {
                        commitEditInstituteActivityState(context, activitiesState)
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        clearState(context: ActivityContext) {
            commitClearState(context)
        },
        getSubscriptions(context: ActivityContext, payload: { idAzienda: number, idAnnoScolastico: number }) {
            var subscriptions: EnterpriseSubscription[] = [];
            var item: EnterpriseSubscription;
            return new Promise<EnterpriseSubscription[]>((resolve, reject) => {
                activityService.getSubscriptions(payload.idAzienda, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach(function (subscription: any) {
                            item = {
                                idAziendaIstitutoAnno: subscription.Id,
                                idIstituto: subscription.IdIstituto,
                                gestioneAlternanza: subscription.GestioneAlternanza,
                                gestioneTirocinioPostDiploma: subscription.GestioneTirocinioDiplomati,
                                gestionePropostaLavorativa: subscription.GestioneProposteLavorative,
                                gestioneAttivitaPomeridiana: subscription.GestioneAttivitaFormPomeridiane,
                                gestioneAttivitaColloqui: subscription.GestioneAttivitaColloqui,
                                gestioneTirocinioEstivo: subscription.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: subscription.GestioneTirocinioFormativo
                            }
                            subscriptions.push(item)
                        });
                        resolve(subscriptions)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        //metodi gestione attivita v2.0 --------------------------------------------------------------

        getAttivitaIstitutiInteresseAzienda(context: ActivityContext, payload: { idAzienda: number, idAnnoScolastico: number, activityType: string }) {
            var listaAttivita: IscrizioneAzienda[] = [];
            var attivita: IscrizioneAzienda;
            return new Promise<IscrizioneAzienda[]>((resolve, reject) => {
                activityService.getAttivitaIstitutiInteresseAzienda(payload.idAzienda, payload.idAnnoScolastico, payload.activityType).then(result => {
                    result.forEach((element: any) => {
                        attivita = {
                            idIscrizione: element.IdIscrizione,
                            idAttivitaIstituto: element.IdAttivita,
                            idIstituto: element.IdIstituto,
                            denominazioneIstituto: element.DenominazioneIstituto,
                            idAnnoScolastico: element.IdAnnoScolastico,
                            idAzienda: element.IdAzienda,
                            dataIscrizione: element.DataIscrizione,
                            dataInizio: element.DataInizio,
                            dataFine: element.DataFine,
                            idTipoAttivita: element.IdTipoAttivita,
                            nomeAttivita: element.NomeAttivita,
                            statoPeriodoIscrizione: element.StatoIscrizione,
                            statoPubblicazione: element.StatoPubblicazione
                        }
                        listaAttivita.push(attivita)
                    });
                    resolve(listaAttivita)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        subscribeToActivityAzienda(context: ActivityContext, payload: { idAttivita: number, idAzienda: number }) {
            return new Promise<number>((rersolve, reject) => {
                activityService.subscribeToActivityAzienda(payload.idAttivita, payload.idAzienda).then(result => {
                    rersolve(result.Id)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getAttivitaIstitutoAllievo(context: ActivityContext, payload: { idAllievo: number, idAnnoScolastico: number, idIstituto: number }) {
            var listaAttivita: IscrizioneAllievo[] = []
            var attivita: IscrizioneAllievo;
            return new Promise<IscrizioneAllievo[]>((resolve, reject) => {
                activityService.getAttivitaIstitutoAllievo(payload.idAllievo, payload.idAnnoScolastico, payload.idIstituto).then(result => {
                    result.forEach((element: any) => {
                        attivita = {
                            idIscrizione: element.IdIscrizione,
                            idAttivitaIstituto: element.IdAttivita,
                            idIstituto: element.IdIstituto,
                            idAnnoScolastico: element.IdAnnoScolastico,
                            idAllievo: element.IdAllievo,
                            dataIscrizione: element.DataIscrizione,
                            dataInizio: element.DataInizio,
                            dataFine: element.DataFine,
                            idTipoAttivita: element.IdTipoAttivita,
                            nomeAttivita: element.NomeAttivita,
                            statoPeriodoIscrizione: element.StatoIscrizione
                        }
                        listaAttivita.push(attivita)
                    });
                    resolve(listaAttivita)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        subscribeToActivityAllievo(context: ActivityContext, payload: { idAttivita: number, idAllievo: number }) {
            return new Promise<number>((resolve, reject) => {
                activityService.subscribeToActivityAllievo(payload.idAttivita, payload.idAllievo).then(result => {
                    resolve(result.Id)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        addWorkshopPreference(context: ActivityContext, payload: { idAzienda: number, idIscrizione: number, scelta: any, referente: any }) {
            return new Promise<string>((resolve, reject) => {
                activityService.addWorkshopPreference(payload.idAzienda,payload.idIscrizione, payload.scelta, payload.referente).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        addColloquioPreference(context: ActivityContext, payload: { idAzienda: number, idIscrizione: number, scelta: any }){
            return new Promise<string>((resolve, reject) =>{
                activityService.addColloquioPreference(payload.idAzienda,payload.idIscrizione, payload.scelta).then(() =>{
                    resolve("ok")
                }).catch(error =>{
                    reject(error)
                })
            })
        }
    }
}

const { commit, read, dispatch } = getStoreAccessors<ActivityState, RootState>("activity");
const getters = activity.getters;

export const readInstituteActivitiesStatus = read(getters.getInstituteActivityState);
export const readActivityState = read(getters.getActivityState);

const actions = activity.actions;

export const dispatchGetInstituteActivityState = dispatch(actions.getInstituteActivityState);
export const dispatchEditInstituteActivityState = dispatch(actions.editInstituteActivityState)
export const dispatchClearState = dispatch(actions.clearState)
export const dispatchGetActivityState = dispatch(actions.getActivityState);
export const dispatchSubscriptions = dispatch(actions.getSubscriptions);
export const dispatchGetAttivitaIstitutiInteresseAzienda = dispatch(actions.getAttivitaIstitutiInteresseAzienda)
export const dispatchSubscribeToActivityAzienda = dispatch(actions.subscribeToActivityAzienda)
export const dispatchGetAttivitaIstitutoAllievo = dispatch(actions.getAttivitaIstitutoAllievo)
export const dispatchSubscribeToActivityAllievo = dispatch(actions.subscribeToActivityAllievo)
export const dispatchAddWorkshopPreference = dispatch(actions.addWorkshopPreference)
export const dispatchAddColloquioPreference = dispatch(actions.addColloquioPreference)

const mutations = activity.mutations;

export const commitEditInstituteActivityState = commit(mutations.editInstituteActivityState);
export const commitEditActivityState = commit(mutations.editActivityState);
export const commitClearState = commit(mutations.clearState)